import {
  FetchTarget,
  FetchTargetVariables,
} from "_graphql/queries/__generated__/fetchTarget";
import {
  FetchTargetsVariables,
  FetchTargets as fetchTargetsType,
} from "../../_graphql/queries/__generated__/fetchTargets";

import { fetchTarget } from "../../_graphql/visal/queries/target";
import { fetchTargets } from "../../_graphql/visal/queries/target";
import { useQuery } from "@apollo/client";

export const useTargets = ({ brokerId }: { brokerId: string }) => {
  const { data, loading, error, refetch } = useQuery<
    fetchTargetsType,
    FetchTargetsVariables
  >(fetchTargets, {
    variables: {
      brokerId,
    },
    fetchPolicy: "network-only",
  });

  return {
    targets: data?.fetchTargets || [],
    loading,
    error,
    refetch,
  };
};

// export interface TargetBadge {
//   id: string;
//   name: string | null;
//   min_points: number | null;
//   max_points: number | null;
//   description: string | null;
//   cash_equivalent: number | null;
//   minimum_cash_equivalent: number | null;
//   gift_basket: GiftInput[] | null;
// }

// export interface Target {
//   id: string;
//   broker_id: string;
//   target_name: string;
//   start_date: Date;
//   target_badges: TargetBadge[] | null;
// }

// export interface FetchTargetResponse {
//   fetchTarget: Target;
// }

export const useTarget = ({ targetId }: { targetId: string }) => {
  const { data, loading, error, refetch } = useQuery<
    FetchTarget,
    FetchTargetVariables
  >(fetchTarget, {
    variables: {
      targetId,
    },
    fetchPolicy: "network-only",
    skip: !targetId,
  });

  return {
    targetBadge: data?.fetchTarget || null,
    badges: data?.fetchTarget?.target_badges || [],
    loading,
    error,
    refetch,
  };
};
